<template>
  <div class="min-h-screen bg-background">
    <PageHeader />

    <main>
      <!-- Top Banner -->
      <div class="bg-[#7c2622] py-16">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h1 class="font-serif text-3xl lg:text-4xl text-white">
            About the Award
          </h1>
          <p class="text-white/70 mt-2">
            Purpose, mission, and integrity of the programme.
          </p>
        </div>
      </div>

      <!-- Content -->
      <section class="py-20 lg:py-28 bg-background">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            <div class="animate-fade-in">
              <p class="text-sm font-medium tracking-widest uppercase text-muted-foreground mb-4">
                About the Award
              </p>

              <h2 class="font-serif text-3xl lg:text-4xl text-foreground mb-6">
                Excellence Discovered, Not Declared
              </h2>
            </div>

            <div
              class="space-y-6 animate-fade-in"
              :style="{ animationDelay: '0.1s' }"
            >
              <p class="text-muted-foreground leading-relaxed">
                The Souvenir Excellence Awards operates on a hidden selection model.
                Unlike conventional awards programmes, there is no open application
                or nomination process. Recipients are identified and evaluated
                entirely without their knowledge, ensuring that only genuine,
                day-to-day excellence is recognised.
              </p>

              <p class="text-muted-foreground leading-relaxed">
                Our concealed evaluation process deploys anonymous field observers
                who assess businesses against undisclosed criteria. This covert
                approach captures authentic operations, customer interactions, and
                product quality — free from the performative behaviour that
                traditional assessments often invite.
              </p>

              <p class="text-muted-foreground leading-relaxed">
                Potential recipients are surfaced through a confidential network
                of industry insiders, past honourees, and trained scouts.
                Businesses are never informed of their candidacy until the moment
                of official announcement.
              </p>
            </div>
          </div>

          <!-- Purpose / Mission / Integrity -->
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-16 pt-16 border-t border-gray-200">

            <!-- Purpose -->
            <div
              class="animate-fade-in"
              :style="{ animationDelay: '0.2s' }"
            >
              <div class="h-12 w-12 bg-[#7c2622]/10 flex items-center justify-center mb-4">
                <div class="h-6 w-6 border-2 border-[#7c2622]"></div>
              </div>

              <h3 class="font-serif text-xl text-foreground mb-2">
                Purpose
              </h3>

              <p class="text-sm text-muted-foreground leading-relaxed">
                To identify and honour souvenir businesses that consistently
                demonstrate authentic excellence — discovered through covert
                observation, not self-promotion.
              </p>
            </div>

            <!-- Mission -->
            <div
              class="animate-fade-in"
              :style="{ animationDelay: '0.3s' }"
            >
              <div class="h-12 w-12 bg-[#7c2622]/10 flex items-center justify-center mb-4">
                <div class="h-6 w-6 border-2 border-[#7c2622] rotate-45"></div>
              </div>

              <h3 class="font-serif text-xl text-foreground mb-2">
                Mission
              </h3>

              <p class="text-sm text-muted-foreground leading-relaxed">
                To elevate industry standards by ensuring recognition is earned
                through genuine merit, assessed under real-world conditions
                without prior notice.
              </p>
            </div>

            <!-- Integrity -->
            <div
              class="animate-fade-in"
              :style="{ animationDelay: '0.4s' }"
            >
              <div class="h-12 w-12 bg-[#7c2622]/10 flex items-center justify-center mb-4">
                <div class="h-6 w-6 rounded-full border-2 border-[#7c2622]"></div>
              </div>

              <h3 class="font-serif text-xl text-foreground mb-2">
                Integrity
              </h3>

              <p class="text-sm text-muted-foreground leading-relaxed">
                To preserve total anonymity throughout the selection process —
                protecting evaluators, candidates, and deliberations from any
                external influence.
              </p>
            </div>

          </div>
        </div>
      </section>
    </main>

    <PageFooter />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import PageFooter from "@/components/PageFooter.vue"

export default {
  name: "About",
  components: {
    PageHeader,
    PageFooter,
  },
}
</script>